const SCROLLER_SELECTOR = '.real-lesson-path__chart-scroll';
const INITIALIZED_ATTRIBUTE = 'data-keyboard-scroll-initialized';

function initializeScroller(scroller) {
  if (scroller.hasAttribute(INITIALIZED_ATTRIBUTE)) return;

  scroller.setAttribute(INITIALIZED_ATTRIBUTE, 'true');
  scroller.addEventListener('keydown', (event) => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    if (scroller.scrollWidth <= scroller.clientWidth) return;

    event.preventDefault();

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const direction = event.key === 'ArrowLeft' ? -1 : 1;
    let left = scroller.scrollLeft + direction * Math.max(scroller.clientWidth * 0.8, 192);

    if (event.key === 'Home') left = 0;
    if (event.key === 'End') left = scroller.scrollWidth - scroller.clientWidth;

    scroller.scrollTo({
      left,
      behavior: reduceMotion ? 'auto' : 'smooth',
    });
  });
}

function initializeTimelineScrollers(root = document) {
  if (root.matches?.(SCROLLER_SELECTOR)) initializeScroller(root);
  root.querySelectorAll?.(SCROLLER_SELECTOR).forEach(initializeScroller);
}

initializeTimelineScrollers();
document.addEventListener('shopify:section:load', (event) => initializeTimelineScrollers(event.target));
